<template>
    <div class="article_nav jsHeadersWrapper">
        <div class="article_nav_inner">
            <div v-if="items.length" class="nav_wrapper">
                <ul>
                    <li
                        v-for="(item, i) in items"
                        :id="`content-builder-link-${item.parentIndex}`"
                        :key="i"
                    >
                        <a
                            :href="`#content-builder-item-${item.parentIndex}`"
                            @click.prevent="scrollSmooth(item.parentIndex)"
                        >
                            {{ getText(item) }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            isMobile: false
        };
    },

    mounted() {
        if (this.items?.length) {
            document.addEventListener('scroll', this.onScroll);
        }

        this.isMobile = window.innerWidth < 992;

        window.addEventListener('resize', this.onResize);
    },

    beforeDestroy() {
        if (this.items?.length) {
            document.removeEventListener('scroll', this.onScroll);
        }

        window.removeEventListener('resize', this.onResize);
    },

    methods: {
        scrollSmooth(index) {
            const element = document.getElementById(
                `content-builder-item-${index}`
            );

            if (!element) {
                return;
            }

            const offsetSpace = this.isMobile ? 110 : 80;

            window.scrollTo({
                top: element.offsetTop - offsetSpace,
                behavior: 'smooth'
            });
        },

        getText(item) {
            const regex = /(<([^>]+)>|&nbsp;)/gi;

            return item.value?.replace(regex, '') || '';
        },

        onScroll() {
            const elements = [];

            for (const { parentIndex } of this.items) {
                const el = document.getElementById(
                    `content-builder-item-${parentIndex}`
                );

                elements.push({ el, parentIndex });
            }

            const { parentIndex } = elements.reduce((previous, current) => {
                const { top } = current.el.getBoundingClientRect();

                return top < 81 ? current : previous;
            });

            const navElements = document.querySelectorAll('.nav_wrapper ul li');

            for (const el of navElements) {
                el.classList = '';
            }

            const activeNavElement = document.getElementById(
                `content-builder-link-${parentIndex}`
            );

            activeNavElement.classList = 'active';
        },

        onResize() {
            this.isMobile = window.innerWidth < 992;
        }
    }
};
</script>
